import { select_device_capabilities } from './selectors';
import { setPeriod } from '../period/actions';
import { dayEndToUnix, dayStartToUnix, todayEndToUnix, todayStartToUnix } from 'utils';
export const applyManyNewData = (map) => (dispatch, getState) => {
    const capabilities = Object.fromEntries(Object.keys(map).map((device_id) => [
        device_id,
        select_device_capabilities(getState(), parseInt(device_id, 10)),
    ]));
    dispatch({
        type: 'APPLY_MANY_NEW_DATA',
        map,
        capabilities,
    });
};
export const applyNewData = (device_id, data) => ({
    type: 'APPLY_NEW_DATA',
    device_id,
    data,
});
const dayChange = () => {
    return {
        type: 'DAY_CHANGE',
    };
};
export const installDateChecker = (dispatch, state) => {
    let last_day = new Date(Date.now());
    const check = () => {
        const cur_day = new Date(Date.now());
        const state_max_day = new Date((state().period.maxtime ?? todayEndToUnix()) * 1e3);
        const state_min_day = new Date((state().period.mintime ?? todayStartToUnix()) * 1e3);
        if (last_day.getDay() !== cur_day.getDay()) {
            dispatch(dayChange());
            if (last_day >= state_min_day && last_day <= state_max_day) {
                dispatch(setPeriod(dayStartToUnix(state_min_day), dayEndToUnix(cur_day)));
            }
        }
        last_day = cur_day;
        setTimeout(check, 5 * 60 * 1e3);
    };
    check();
};
